import { render, staticRenderFns } from "./rake-back.vue?vue&type=template&id=a672a0fc&lang=pug&"
import script from "./rake-back.vue?vue&type=script&lang=js&"
export * from "./rake-back.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports